const n8nChatbotDictEN = {
  // Interface texts
  chatTitle: "Extraconomy Chat",
  chatTitleDev: "Extraconomy Chat (Dev Mode)",
  statusOnline: "Online",
  statusOffline: "Offline",
  statusChecking: "Checking...",
  statusDevMode: "Dev Mode",
  placeholder: "Type your message...",
  tooltip: "Contact us!",

  // Welcome message
  welcomeMessage: "Hello! I'm Extraconomy's virtual assistant. How can I help you today?",

  // Loading states
  typing: "Typing...",

  // Error messages
  errorGeneric: "Sorry, I'm having technical difficulties at the moment. Please contact us at: support@extraconomy.com",
  errorWithDetails: "Sorry, I'm having technical difficulties at the moment. Please contact us at: support@extraconomy.com\n\nError: {error}",

  // Fallback responses
  fallbackResponse: "Thank you for your message! I'm here to help with information about Extraconomy. You can ask about registration, plans, features or any other questions!"
};

export default n8nChatbotDictEN;
